<template>
  <div>
    <PageHeader :items="items" />
    <validation-observer ref="simpleRules">
      <div class="card">
        <div class="card-body">
          <div class="row mb-2">
            <div class="col-md-6">
              <validation-provider
                #default="{ errors }"
                name="Name"
                rules="required"
              >
                <TextInput
                  v-model="form.name"
                  type="text"
                  :label="$t('name')"
                  :tooltipMessage="$t('name')"
                  :required="true"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
            <div class="col-md-6">
              <label class="input-label form-label" for="cars">
                {{ $t("company") }}
              </label>
              <MultiSelectInput
                v-model="form.company"
                :options="customers"
                :query="{ isMultiSelect: true }"
                label="companyName"
                trackBy="id"
                :key="form.company"
                moduleName="customers"
                :multiple="false"
                ><template #option="{ props }">
                  <div>
                    <p>
                      {{ props.option.companyNumber }} -
                      {{ props.option.companyName }}
                    </p>
                  </div>
                </template>
              </MultiSelectInput>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-md-6">
              <label class="input-label form-label" for="cars">
                {{ $t("roles") }}
              </label>
              <multi-select
                v-model="form.roles"
                :multiple="true"
                label="title"
                track-by="id"
                :options="roles"
              />
            </div>
            <div class="col-md-6">
              <label class="input-label form-label" for="cars">
                {{ $t("status") }}
              </label>

              <select class="input-form form-control" v-model="form.status">
                <option value="1">
                  {{ $t("active") }}
                </option>
                <option value="0">
                  {{ $t("inactive") }}
                </option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <label class="input-label form-label" for="cars">
                {{ $t("type") }}
              </label>
              <multi-select
                v-model="form.type"
                :multiple="false"
                label="label"
                track-by="value"
                :options="keyTypes"
              />
              <!-- <select class="input-form form-control" v-model="form.type">
                <option :value="1">
                  {{ $t("Owner") }}
                </option>
                <option :value="2">
                  {{ $t("Partner") }}
                </option>
                <option :value="3">
                  {{ $t("customer") }}
                </option>
              </select> -->
            </div>
          </div>
          <div class="row"></div>
        </div>
      </div>

      <div class="d-flex align-items-center gap-2 justify-content-end">
        <router-link
          class="btn btn-primary d-flex align-items-center gap-1"
          to="/api-keys"
        >
          {{ $t("cancel") }}
        </router-link>
        <b-button
          variant="primary"
          @click="createAPI"
          class="d-flex align-items-center gap-1"
          :disabled="isFormInvalid"
        >
          <feather-icon icon="PlusIcon" size="12" />
          <span>{{ $t("createApiKey") }}</span>
        </b-button>
        <b-button
          variant="primary"
          @click="showKeyModal = true"
          v-if="clientID && clientSecret"
        >
          {{ $t("showAPIKey") }}
        </b-button>
      </div>
    </validation-observer>
    <div class="custom-modal" v-show="showKeyModal" >
      <div class="modal-overlay"></div>
      <div class="modal-content justify-content-center">
        <div class="modal-md modal-bg">

          <div class="modal-header">
            <h3>{{ $t("apiKey") }}</h3>
            <p style="color: red">
              {{
                $t(
                  "apikeytext"
                )
              }}
            </p>
            <div class="x-icon" @click="closeKeyModal">
              <feather-icon size="16" icon="XIcon" />
            </div>
          </div>
          <div class="modal-body p-2">
            <KeyModal
              :clientID="clientID"
              :clientSecret="clientSecret"
              @toggleModal="toggleModal = $event"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TextInput from "@/components/TextInput.vue";
import PageHeader from "@/components/PageHeader.vue";
import MultiSelect from "vue-multiselect";
import MultiSelectInput from "@/components/MultiSelectInput.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapGetters } from "vuex";
import { required, email } from "@validations";
import KeyModal from "./components/KeyModal.vue";
import formDirtyMixin from "@/mixins/formDirtyMixin";

export default {
  components: {
    TextInput,
    PageHeader,
    MultiSelect,
    ValidationProvider,
    ValidationObserver,
    KeyModal,
    MultiSelectInput,
  },
  mixins: [formDirtyMixin],
  computed: {
    ...mapGetters("roles", ["roles"]),
    ...mapGetters("customers", ["customers"]),
    items() {
      return [
        {
          text: this.$t("dentalTwin"),
          to: "/home",
        },
        {
          text: this.$t("settings"),
          to: "/settings",
        },
        {
          text: this.$t("apiKeys"),
          to: "/api-keys",
        },
        {
          text: this.$t("create"),
          active: true,
        },
      ];
    },
    isFormInvalid() {
      return !this.form.name;
    },
  },
  data() {
    return {
      originalForm: null,
      form: {
        name: "",
        company: "",
        type: "",
        status: "",
        roles: [],
      },
      clientID: "",
      clientSecret: "",
      showKeyModal: false,
      keyTypes: [
        { value: "owner", label: this.$t("Owner") },
        { value: "partner", label: this.$t("Partner") },
        { value: "customer", label: this.$t("customer") },
      ],
    };
  },
  watch: {
    form: {
      handler(newVal) {
        this.isFormDirty = JSON.stringify(newVal) !== this.originalForm;
      },
      deep: true,
    },
  },
  async created() {
    this.$store.commit("showLoader", true);
    await this.$store.dispatch("customers/list", { isMultiSelect: true });
    await this.$store.dispatch("roles/list", {
      limit_start: 0,
      limit_count: 100,
    });

    this.originalForm = JSON.stringify(this.form);
    this.$store.commit("showLoader", false);
  },

  methods: {
    closeKeyModal() {
      this.showKeyModal = false;
    },
    async createAPI() {
      this.$refs.simpleRules.validate().then(async (success) => {
        if (success) {
          try {
            this.$store.commit("showLoader", true);
            const payload = {
              ...this.form,
              set_company_id: this.form.company?.id ?? "",
              type: this.form.type?.value ?? "",
              roles:
                this.form.roles && this.form.roles.length
                  ? this.form.roles.map((role) => role.id)
                  : [],
            };
            console.log("payload", payload);
            const response = await this.$store.dispatch(
              "apikeys/create",
              payload
            );
            this.clientID = response?.data?.client_id ?? "";
            this.clientSecret = response?.data?.secret ?? "";
            this.showKeyModal = true;
            this.isFormDirty = false;
            this.originalForm = JSON.stringify(this.form);
            await this.$store.dispatch("apikeys/list");
          } catch (e) {
            console.error("api error ___", e);
          } finally {
            this.$store.commit("showLoader", false);
          }
        }
      });
    },
  },
};
</script>

<style scoped>
#nprogress {
  position: relative;
  z-index: 9999999;
}

.white-color {
  color: white !important;
}

.vgt-responsive {
  overflow-x: visible !important;
}
</style>
